import { createBrowserHistory } from 'history';
import { BASENAME } from '../constants';

// Create a history object that can be used in Redux thunks
export const history = createBrowserHistory({ basename: BASENAME });

